module.exports = __webpack_public_path__ + "media/images/covers/buka-deposito-sekarang-3f62589867a21feecbb8cedf7a660758.png";